<template>
  <div>
    <tabs
      v-if="!$apollo.loading"
      cache-lifetime="0"
      :options="{ useUrlFragment: false }"
    >
      <tab
        v-for="(items, category, index) in widgets"
        :key="index"
        :name="formatCategoryTitle(category)"
        class="tab-content"
      >
        <Widget
          v-for="item in items"
          :key="item.id"
          :widget="item"
          :campaign-id="campaignId"
          class="mb-6 md:mb-8"
          @adding-widget="$emit('update:addingWidget', $event)"
        />
      </tab>
    </tabs>

    <div v-if="$apollo.loading" class="w-full p-4">
      <Loader />
    </div>
  </div>
</template>

<script>
import groupBy from "lodash.groupby";
import capitalize from "lodash.capitalize";
import { Widgets } from "@/graphql/queries";
import Loader from "@/components/UI/Loader";
import Widget from "./Widget";

export default {
  apollo: {
    widgets: {
      query: () => Widgets,
      update: (data) => groupBy(data.widgets, "category"),
    },
  },
  name: "Widgets",
  components: { Loader, Widget },
  props: {
    campaignId: {
      required: true,
      type: String,
    },
  },
  methods: {
    formatCategoryTitle(title) {
      return capitalize(title);
    },
  },
};
</script>

<style scoped>
>>> .tabs-component-tabs {
  @apply border-0 mb-2 text-xs;

  @screen md {
    @apply text-sm mb-0;
  }
}
</style>
